import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

//自适应font-size
import 'amfe-flexible';
import '@/public/mobile/flexible.js';
import '@/public/styles/reset.css';
import '@/assets/css/common/iconfont.css'
import '@/assets/css/common/mianfont.css'

import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import { Toast,Dialog} from 'vant';
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import ClipBoard from 'vue-clipboard2';
Vue.use(ClipBoard);

import router from '@/router';
import storage from "@/utils/storage"
//引入vuex
import store from "@/store"

//全局过滤器
import * as Filters from '@/utils/plugins'
Object.keys(Filters).forEach(key => {
  Vue.filter(key, Filters[key]);
})

//按需引入
new Vue({
  router,
  store,
  beforeCreate() {
    Vue.prototype.$bus = this; //安装全局事件总线
    Vue.prototype.$storage = storage;
    Vue.prototype.$oosurl = 'https://oss.sbooip.com';
    Vue.prototype.$httpurl = 'http://static.sbooip-net.com/public';
  },
  render: h => h(App),
}).$mount('#app');
